module.exports = __webpack_public_path__ + "dr_pepper.embedded.svg?bdd97f344860a173a5f5007f031a7cd6";


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/images/dr_pepper.embedded.svg
// module id = 1303
// module chunks = 33